export function useFormStyles() {
    const baseFormElement = {
        outer: 'w-full',
        label:  'font-medium mb-2',
        inner: 'mt-2',
        messages: 'text-red-500 text-sm mt-2 font-medium'
    }
    
    const formElement = {
        ...baseFormElement,
        input: 'w-full focus:border-primary-500',
    }
    
    const readonlyFormElement = {
        ...baseFormElement,
        input: 'bg-gray-50 w-full',
    }

    return { baseFormElement, formElement, readonlyFormElement }
}

export function useDropdownStyles() {
    const dropdownItem = `group flex w-full items-center rounded-md px-2 py-2 text-sm hover:bg-primary-500 hover:text-white`

    const activeDropdownItem =  `bg-primary-500 text-white`

    const inactiveDropdownItem = `text-gray-900`

    return { dropdownItem, activeDropdownItem, inactiveDropdownItem }
}


export function useDialogStyles() {
    const dialogTitle = `text-lg font-medium leading-6 text-gray-900`

    const dialogPanel = `w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`

    return { dialogTitle, dialogPanel }
}